var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0041 15.0041C11.8725 15.0049 11.742 14.9796 11.6202 14.9299C11.4983 14.8801 11.3875 14.8068 11.2941 14.7141L7.29409 10.7141C7.20085 10.6209 7.12689 10.5102 7.07643 10.3883C7.02597 10.2665 7 10.136 7 10.0041C7 9.87223 7.02597 9.74166 7.07643 9.61984C7.12689 9.49802 7.20085 9.38733 7.29409 9.29409C7.38733 9.20085 7.49802 9.12689 7.61984 9.07643C7.74166 9.02597 7.87223 9 8.00409 9C8.13595 9 8.26652 9.02597 8.38834 9.07643C8.51016 9.12689 8.62085 9.20085 8.71409 9.29409L12.0041 12.6041L15.3041 9.42409C15.3961 9.3218 15.5082 9.23959 15.6334 9.18261C15.7586 9.12562 15.8942 9.09508 16.0318 9.0929C16.1693 9.09072 16.3059 9.11695 16.4328 9.16994C16.5598 9.22293 16.6744 9.30155 16.7696 9.40087C16.8648 9.5002 16.9385 9.61809 16.986 9.74719C17.0336 9.87628 17.054 10.0138 17.0459 10.1511C17.0379 10.2885 17.0016 10.4227 16.9394 10.5453C16.8771 10.668 16.7902 10.7765 16.6841 10.8641L12.6841 14.7241C12.5012 14.9004 12.2581 15.0005 12.0041 15.0041Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.174f3a11dfcb0e4c4241c7ec9318b9e4.svg";
export { ForwardRef as ReactComponent };